export default __webpack_public_path__ + "static/media/d'syrikah-project.0e43deb6.png";